export default __webpack_public_path__ + "static/media/background-mobile.a9fdc799.svg";